module.exports = __webpack_public_path__ + "static/new_logo-dbe14650cbc7b6fb13d9a4c3d73173d9.png";